import React from 'react';
import { Box, Typography, Stack, Chip } from '@mui/material';
import {
  DOCUMENT_VIEW_DIALOG_STYLES,
  getFileIcon,
  getFileTypeLabel,
} from '../../../../../common/styles/dialogStyles';
import { WriteoffDocumentView } from '../../../../../../services/WriteoffService/types/documentTypes';

interface DocumentHeaderProps {
  document: WriteoffDocumentView;
}

export const DocumentHeader: React.FC<DocumentHeaderProps> = ({ document }) => (
  <Box sx={DOCUMENT_VIEW_DIALOG_STYLES.cardWithFlex}>
    <Box sx={DOCUMENT_VIEW_DIALOG_STYLES.fileIconBox}>{getFileIcon(document.extension)}</Box>
    <Box flex={1}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, wordBreak: 'break-word' }}>
        {document.fileName}
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap">
        <Chip
          label={getFileTypeLabel(document.extension)}
          size="small"
          sx={DOCUMENT_VIEW_DIALOG_STYLES.chip}
        />
        <Chip label={document.extension.toUpperCase().slice(1)} size="small" variant="outlined" />
      </Stack>
    </Box>
  </Box>
);

export default DocumentHeader;
